export const Texts = {
  promptTitle: 'Exit and discard changes?',
  promptCancelButton: 'Stay',
  promptConfirmButton: 'Exit',
  promptMessage: 'Are you sure you want to exit?  All of your current changes will be discarded.',
};
